import React, { useState } from 'react';
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import { Autoplay, EffectFade } from "swiper/modules";
import assets from '../assets/assets';

const MissionVision = () => {
    const [swiperInstance, setSwiperInstance] = useState(null);

    const {about_slider_bg, about_img, aboit_img2} = assets();

    // Handle previous slide click
    const handlePrevClick = () => {
        if (swiperInstance) {
            swiperInstance.slidePrev();
        }
    };

    // Handle next slide click
    const handleNextClick = () => {
        if (swiperInstance) {
            swiperInstance.slideNext();
        }
    };


    const companyInfo = [
        {
            title: "Company Mission",
            heading: "We help to business growth and solution.",
            description:
                "Lorem ipsum is simply dummy text of the printing and typesetting industry. Lorem ipsum has been industry's standard dummy text ever since the when an unknown adipiscing elit do eiusmod tempor incididunt ut labore printer took and scrambled it specimen book.",
        },
        {
            title: "Company Vision",
            heading: "A business plan and performance ideas.",
            description:
                "Lorem ipsum is simply dummy text of the printing and typesetting industry. Lorem ipsum has been industry's standard dummy text ever since the when an unknown adipiscing elit do eiusmod tempor incididunt ut labore printer took and scrambled it specimen book.",
        },
        {
            title: "Company Value",
            heading: "Make the creative solutions for business.",
            description:
                "Lorem ipsum is simply dummy text of the printing and typesetting industry. Lorem ipsum has been industry's standard dummy text ever since the when an unknown adipiscing elit do eiusmod tempor incididunt ut labore printer took and scrambled it specimen book.",
        },
    ];

    return (
        <section class="position-relative overflow-hidden">
            <div class="container">
                <div class="row justify-content-center align-items-center mb-3">
                    <div class="col-xl-5 col-lg-6 md-mb-14 sm-mb-18 xs-mb-23 position-relative" data-anime='{ "translateY": [0, 0], "opacity": [0,1], "duration": 800, "delay": 100, "staggervalue": 300, "easing": "easeOutQuad" }'>
                        <div class="w-smm-75 sm-w-80 " data-animation-delay="200" data-shadow-animation="true" data-bottom-top="transform: translateY(50px)" data-top-bottom="transform: translateY(-50px)">
                            <img alt="" class="border-radius-6px w-100" src={about_img} />
                        </div>
                        <div class="position-absolute top-30px z-index-8 left-minus-90px lg-left-minus-25px sm-left-minus-0px lg-w-30">
                            <img alt="" src={aboit_img2}/>
                        </div>
                    </div>
                    <div class="col-xl-5 offset-xl-1 col-lg-6 text-center text-lg-start" data-anime='{ "translateY": [0, 0], "opacity": [0,1], "duration": 800, "delay": 150, "staggervalue": 300, "easing": "easeOutQuad" }'>
                        <Swiper
                            slidesPerView={1}
                            spaceBetween={10}
                            autoplay={{
                                delay: 4000,
                                disableOnInteraction: false,
                            }}
                            loop={true}
                            speed={1000}
                            breakpoints={{
                                0: {
                                    slidesPerView: 1,
                                },
                            }}
                            modules={[EffectFade, Autoplay]}
                            className="mySwiper"
                            onSwiper={setSwiperInstance}
                        >
                            {companyInfo?.map((about, index) => (
                                <SwiperSlide key={index} className="rounded">
                                    <div class="swiper-slide">
                                        <span class="ps-25px pe-25px mb-20px text-uppercase text-base-color fs-14 lh-42px fw-700 border-radius-100px bg-gradient-very-light-gray-transparent d-inline-block">{about?.title}</span>
                                        <h3 class="text-dark-gray fw-700 ls-minus-1px mb-20px">{about?.heading}</h3>
                                        <p class="w-95 xl-w-100">{about?.description}</p>
                                    </div>
                                </SwiperSlide>
                            ))}
                        </Swiper>
                        <div class="d-flex justify-content-center justify-content-lg-start">
                            <div onClick={handlePrevClick} class="slider-one-slide-prev-1 swiper-button-prev slider-navigation-style-04 border border-color-extra-medium-gray bg-white"><i class="bi bi-arrow-left-short icon-very-medium text-dark-gray"></i></div>
                            <div onClick={handleNextClick} class="slider-one-slide-next-1 swiper-button-next slider-navigation-style-04 border border-color-extra-medium-gray bg-white"><i class="bi bi-arrow-right-short icon-very-medium text-dark-gray"></i></div>
                        </div>
                    </div>
                </div>
            </div>
            <img class="position-absolute bottom-minus-50px right-minus-50px z-index-minus-1" alt="" src={about_slider_bg} />
        </section>

    );
};

export default MissionVision;